export default __webpack_public_path__ + "static/media/noBread.367e2bee.gif";